module.exports = __webpack_public_path__ + "img/edit.41edc8b9.svg";